var _style, _path, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCastaliaLoaderDropSplash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    fill: "none",
    role: "img",
    "aria-label": "Loading",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.drop{animation:cx-fall 2.2s ease-in infinite}\n@keyframes cx-fall{0%{transform:translateY(-40px);opacity:0}10%{opacity:1}40%{transform:translateY(0);opacity:1}42%,100%{transform:translateY(0);opacity:0}}\n.splash,.splash2{transform-box:fill-box;transform-origin:center;opacity:0}\n.splash{animation:cx-splash 2.2s ease-out infinite}\n.splash2{animation:cx-splash2 2.2s ease-out infinite}\n@keyframes cx-splash{0%,40%{transform:scale(.06);opacity:0}42%{opacity:1}100%{transform:scale(1);opacity:0}}\n@keyframes cx-splash2{0%,55%{transform:scale(.06);opacity:0}57%{opacity:.8}100%{transform:scale(.7);opacity:0}}\n@media (prefers-reduced-motion: reduce){.drop,.splash,.splash2{animation:none}.drop{opacity:0}.splash{opacity:1;transform:scale(.6)}.splash2{opacity:.6;transform:scale(.35)}}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "M60 56 C60 56 53 65 53 70 A7 7 0 0 0 67 70 C67 65 60 56 60 56 Z",
    fill: "#E84BFA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "splash",
    cx: 60,
    cy: 80,
    rx: 50,
    ry: 15,
    stroke: "#E84BFA",
    strokeWidth: 4,
    vectorEffect: "non-scaling-stroke"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "splash2",
    cx: 60,
    cy: 80,
    rx: 50,
    ry: 15,
    stroke: "#E84BFA",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastaliaLoaderDropSplash);
export default __webpack_public_path__ + "static/media/castalia-loader-drop-splash.9e18709f120802c7c5dc3f0a418239f2.svg";
export { ForwardRef as ReactComponent };